import { defineSlotRecipe } from '@chakra-ui/react';

import { sidebarSlots } from '../slots';

export default defineSlotRecipe({
  slots: sidebarSlots,
  base: {
    body: {
      alignItems: 'center',
    },
    card: {
      bg: 'brandSecondary.solid',
      borderRadius: 'lg',
      boxShadow: 'md',
      color: 'white',
      gap: 4,
      p: 6,
      w: 'full',
    },
    cardSubtext: {
      color: 'brandSecondary.muted',
    },
    // The sidebar quote ProgressCircle is styled via these slots (consumed in
    // sidebar-quote-header) rather than the global `progressCircle` recipe, so
    // the per-tenant look stays scoped to the sidebar and doesn't affect every
    // ProgressCircle in the app. Reconsider consolidating into the global
    // recipe if/when other surfaces need the same treatment.
    progressCircle: {},
    progressRange: {
      stroke: 'brandPrimary.solid',
    },
    progressTrack: {},
    root: {
      bg: 'brandSecondary.fg',
      color: 'fg.inverted',
    },
    separator: {
      borderColor: 'brandSecondary.emphasized',
    },
  },
});
